<template>
  <div v-bem>
    <div class="row">
      <div class="col-md-3">
        <div v-bem:label="{ checked }">{{ label }}:</div>
      </div>
      <div class="col-md-9">
        <img :src="url" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryImage',
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.summary-image {
  line-height: 1.2;

  & + & {
    margin-top: utils.f-convert-to-rem(32);
  }

  @at-root #{&}__label {
    font-weight: 500;
    margin-bottom: utils.f-rem-calc(16);

    @at-root #{&}--checked {
      display: block;
      padding-left: utils.f-rem-calc(24);
      background-image: url('./images/check.svg');
      background-repeat: no-repeat;
      background-position: left center;
    }
  }
}
</style>
